import React from 'react';
import Fab from '../Navbar/Fab';
import { useIntl } from 'react-intl';
import { useAtom } from 'jotai';
import { themeAtom } from '../../Atoms';
import PaletteRoundedIcon from '@mui/icons-material/PaletteRounded';

const ThemeFab = function ThemeFab({ size, sx, iconColor }) {
  const intl = useIntl();
  const [theme, setTheme] = useAtom(themeAtom);
  return (
    <Fab
      size={size}
      sx={sx}
      title={
        theme === 'light'
          ? intl.messages.SWITCH_TO_DARK_THEME
          : intl.messages.SWITCH_TO_LIGHT_THEME
      }
      onClick={() => {
        setTheme(theme === 'light' ? 'dark' : 'light');
        localStorage.setItem('theme', theme === 'light' ? 'dark' : 'light');
      }}
    >
      <PaletteRoundedIcon sx={{ color: iconColor || 'inherit' }} />
    </Fab>
  );
};

export default ThemeFab;
